/// <reference path="appbase.ts" />
/// <reference path="../classes/LotInfoBox.ts" />

namespace TerminalApp {

    class Audit_Zone {
        static active: Audit_Zone;
        container = document.createElement("div");
        button_container = document.createElement("div");
        list_container = document.createElement("div");
        dirty_label: HTMLElement;
        button: HTMLElement;
        zone: SP.AuditZoneInfo;
        constructor(z: SP.AuditZoneInfo) {
            this.button_container.innerHTML = `<div class="btn noselect list_button profile_list_button"><i class="fas fa-check icon" aria-hidden="true"></i><span class="text big left">${z.name}</span><span class="label" style="background-color: rgb(167 80 80);">0</span></div>`;
            this.button = this.button_container.querySelector(".btn");
            this.dirty_label = this.button.querySelector(".label");

            this.button.addEventListener("click", async () => {
                var current = Audit_Zone.active;

                if (current) {
                    Audit_Zone.active = null;
                    current.button.classList.remove("selected"); //unselect button
                    current.list_container.innerHTML = "";
                    current.list_container.style.display = "none";
                    current.dirty_label.style.backgroundColor = "rgb(167 80 80)";
                }

                if (current != this) {
                    Audit_Zone.active = this;
                    this.dirty_label.style.backgroundColor = "#586d4c";
                    this.button.classList.add("selected");
                    this.list_container.style.display = "block";

                    //move to top:
                    this.container.parentElement.prepend(this.container);
                    this.loadDirtyLocations(null);
                    ignoreHashChange = true;
                    SP.setHash("zoneId", this.zone.id);
                    await SP.sleep(1);
                    ignoreHashChange = false;
                }
                else {
                    SP.setHash("zoneId", null);
                }
            });



            this.container.appendChild(this.button_container);
            this.container.appendChild(this.list_container);
            this.update(z);
        }

        async loadDirtyLocations(currentPlacementId: number) {
            var z = await SP.Data.Audit.getAuditZonePlacementDatas(this.zone.id, currentPlacementId, 10);
            this.update(z);
            //show next placements
        }

        update(z: SP.AuditZoneInfo) {
            if (z.dirtyCount <= 0) {
                this.container.remove();
                return;
            }

            this.zone = z;
            this.dirty_label.innerHTML = z.dirtyCount.toString();

            if (z.placementDatas) {
                this.list_container.innerHTML = "";
                z.placementDatas.forEach(data => {
                    var box = document.createElement("div");
                    box.classList.add("audit_zone_placement");
                    var sp = new PlacementInfoBox(data, true, null);
                    box.appendChild(sp.container);
                    this.list_container.appendChild(box);
                });


            }
        }
    }

    class Audit_Zone_List {
        container = document.createElement("div");
        list_container = document.createElement("div");
        zones: { [id: string]: Audit_Zone } = {};
        constructor() {
            this.container.innerHTML = `<br><h1>${SP.Localize('sentance_audit_zones')}</h1>`;
            this.container.appendChild(this.list_container);
        }

        updateZone(z: SP.AuditZoneInfo) {
            var zone = this.zones[z.id];
            if (!zone) {
                this.zones[z.id] = zone = new Audit_Zone(z);
                this.list_container.appendChild(zone.container);
            }
            zone.update(z);
        }

        async update() {
            //reset zones
            for (var z in this.zones) {
                var zone = this.zones[z];
                zone.zone.dirtyCount = 0;
            }

            //update zones
            var zones = await SP.Data.Audit.getAuditZoneInfos();
            var hashZone = SP.getHash("zoneId");
            zones.forEach(z => {
                this.updateZone(z);
            });

            //remove non updated zones
            for (var z in this.zones) {
                var zone = this.zones[z];
                if (zone.zone.dirtyCount == 0) {
                    zone.container.remove();
                }

                if (zone.zone.id == hashZone && !zone.button.classList.contains("selected")) {
                    zone.button.click();
                }
            }

            //toggle audits
            this.container.style.display = zones.length ? "block" : "none";
        }
    }

    class AuditItem {
        container: HTMLElement = document.createElement("div");
        count_container: HTMLElement;
        diff_container: HTMLElement;
        item: SP.ItemInfo;
        amt = 0;
        max = 0;
        amt_input: HTMLInputElement;
        constructor(item: SP.ItemInfo, new_item: boolean, qty:number) {
            var name = (item.manufacturerName + " " + item.modelNo).trim();
            this.container.classList.add("order_item_new", "faded");
            this.container.innerHTML = `
            
                <div class="image"><img src="${item.imageUrl}"></div>
                <div class="sku ellipsis"><b>${item.sku}</b>${name ? " - " + name : ""}</div>
                <div class="name ellipsis">${item.description}</div>
                <div class="barcodes ellipsis">${item.barcodes.join(", ")}</div>
                <div class="buttons">
                    ${new_item ? '<div class="regulation new-item"><i class="fa-solid fa-plus"></i></div>' : ''}
                    <div class="regulation difference">+3</div>
                    <div class="minus button label"><i class="fa-solid fa-minus"></i></div>
                    <div class="label amt" style="background-color: rgb(160, 171, 147);">
                    </div>
                    <div class="plus button label"><i class="fa-solid fa-plus"></i></div>
                </div>`;

            this.count_container = this.container.querySelector(".label.amt");
            this.diff_container = this.container.querySelector(".regulation.difference");

            SP.bindClickHold(this.container.querySelector(".plus") as HTMLElement, 500,
                () => { this.updateAmount(1, false); SP.Sounds.Click.play(); }, //click
                () => { if (this.amt < this.max) this.updateAmount(this.max, true); SP.Sounds.Click.play(); } //hold
            );

            SP.bindClickHold(this.container.querySelector(".minus") as HTMLElement, 500,
                () => { this.updateAmount(-1, false); SP.Sounds.Click.play(); }, //click
                () => { this.updateAmount(this.amt > this.max ? this.max : 0, true); SP.Sounds.Click.play(); } //hold
            );

            var img = this.container.querySelector(".image");
            img.addEventListener("click", () => {
                itemShortcutAssistant.open_with_info(item);
            });

            this.item = item;

            this.count_container.addEventListener("click", () => {
                if (!this.amt_input) {
                    this.count_container.innerHTML = `<input type='number' class='amt_input' value='${this.amt}' />`;
                    this.amt_input = this.count_container.querySelector(".amt_input");
                    this.amt_input.addEventListener("input", () => {
                        this.updateAmount(parseFloat(this.amt_input.value) ?? 0, true);
                    });

                    this.amt_input.addEventListener("blur", () => {
                        var val = parseFloat(this.amt_input.value) ?? 0;
                        this.amt_input = null;
                        this.updateAmount(val, true);
                    });
                }
                this.amt_input.focus();
                this.amt_input.select();
            });

            this.container.addEventListener("click", () => {
                this.focus();
            });

            if (new_item) this.updateAmount(qty, true);
            else this.render();
        }

        addLot(lot: SP.StockingLotInfo) {
            this.max += lot.placementQuantity;
            this.amt += lot.placementQuantity;
            this.render();
        }

        updateAmount(amt: number, set: boolean) {

            this.amt = Math.max(0, set ? amt : this.amt + amt);
            App_audit_placement.instance.updateChangeCount();
            this.render();
        }

        focus() {
            var current = document.querySelector(".fcs_items .focus");
            if (current) current.classList.remove("focus");
            this.container.classList.add("focus");
            this.container.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
        }

        render() {
            var diff = SP.fixFloatingNumber(this.amt - this.max);

            if (!this.amt_input) {
                this.count_container.innerHTML = this.amt + " / " + this.max;
                this.count_container.style.backgroundColor = (diff == 0 ? "" : "rgb(160, 171, 147)");
            }

            this.diff_container.classList.remove("grad-green");
            this.diff_container.classList.remove("grad-red");
            this.diff_container.classList.add((diff > 0 ? "grad-green" : diff < 0 ? "grad-red" : "white"));
            this.diff_container.innerHTML = diff > 0 ? "+" + diff.toString() : diff < 0 ? diff.toString() : '<i class="fa-solid fa-check"></i>';
        }
    }
    class App_audit_placement extends AppBase {
        auditZoneList = new Audit_Zone_List();
        bound = false;
        currentPlacementId: number;
        currentBarcode: string;
        placeholder_container = document.getElementById("afc_placeholder");
        placeholder_container_image = this.placeholder_container.querySelector("img");
        content_container = document.getElementById("afc_content");
        button_reset = document.getElementById("afc_reset_count");
        button_add_item = document.getElementById("afc_additem");
        button_pick_placement = document.getElementById("afc_search_placement");
        header_container = document.querySelector(".fcs .placement_header");
        items_container = document.querySelector(".fcs .items");
        change_count_container = document.getElementById("fcs_change_count");
        button_submit = document.getElementById("fcs_submit");
        placement: SP.StockPlacementInfo;
        stockCustomers: SP.CustomerInfo[];
        items: { [id: string]: AuditItem };
        static instance: App_audit_placement;

        constructor() {
            super("app_audit_placement");
            App_audit_placement.instance = this;
            this.button_submit.addEventListener("click", async () => {
                StartLoading();
                this.button_submit.classList.add("disabled");
                await this.commit();
                this.button_submit.classList.remove("disabled");
                StopLoading();
            });

            this.button_add_item.addEventListener("click", () => {
                this.scanBarcode(null);
            });

            this.button_pick_placement.addEventListener("click", () => {
                placementPickerAssistant.open(null, null, (p) => {
                    this.selectPlacementId(p.id);
                });
            });

            this.button_reset.addEventListener("click", () => {
                this.resetCounts();
            });

            this.placeholder_container_image.style.pointerEvents = "all";
            this.placeholder_container_image.addEventListener("click", () => {
                placementPickerAssistant.open(null, null, (p) => {
                    this.scanPlacement(p.id.toString());
                });
            });

            this.container.appendChild(this.auditZoneList.container);
        }

        resetCounts() {
            for (var id in this.items) {
                this.items[id].updateAmount(0, true);
            }
        }

        reset() {
            this.button_add_item.classList.add("disabled");
            this.button_reset.classList.add("disabled");
            this.content_container.style.display = "none";
            this.placeholder_container.style.display = "";
            this.header_container.innerHTML = "";
            this.items_container.innerHTML = "";
            this.change_count_container.innerHTML = "0";
            this.placement = null;
            this.changes = 0;
            this.items = {};
        }

        async onOpen() {
            this.reset();
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("t", this.scanTote, this);
                barcodeListener.on("sp", this.scanPlacement, this);
                barcodeListener.on(null, this.scanBarcode, this);
            }

            var placeId = SP.getHash("placementId");
            if (placeId) this.selectPlacementId(parseInt(placeId));

            this.auditZoneList.update();
        }

        async onClose() {
            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("t", this.scanTote);
                barcodeListener.off("sp", this.scanPlacement);
                barcodeListener.off(null, this.scanBarcode);
            }
            itemSearchAssistant.close();
            placementPickerAssistant.close();

            this.reset();
        }

        commiting = false;
        async commit() {
            if (this.commiting) return;
            this.commiting = true;
            try {
                var regulations = {} as any;

                for (var id in this.items) {
                    var regulation = this.items[id].amt - this.items[id].max;
                    if (regulation != 0) regulations[id] = regulation;
                }

                var data = {
                    itemRegulations: regulations,
                    placementId: this.placement.placement.id,
                    note: "",
                    reason: SP.AuditReason.StockAudit
                };


                var result = await SP.post<any>("/api/v1/audit/commit/", data);

                if (result.status != 200) {
                    await SP.alertX(result.status + ": " + result.msg);
                }
                else {
                    for (var id in this.items) {
                        this.items[id].max = this.items[id].amt;
                        this.items[id].render();
                    }
                    SP.Sounds.Success.play();
                    this.changes = 0;
                }

                Audit_Zone.active?.loadDirtyLocations(this.placement.placement.id);

            }
            finally {
                this.commiting = false;
            }
        }

        async selectPlacementId(placementId: number) {
            if (this.changes && this.currentPlacementId != placementId && !(await SP.confirmX("" + SP.Localize("word_discard_changes") + "?"))) return;
            StartLoading();

            Audit_Zone.active?.loadDirtyLocations(placementId);

            this.reset();
            this.currentPlacementId = placementId;
            this.currentBarcode = null;
            ignoreHashChange = true;
            SP.setManyHash({ "placementId": placementId.toString() });

            this.placement = await SP.Data.Stock.getPlacementInfo(placementId, false);
            this.stockCustomers = (await SP.Data.Customer.getCustomerInfos(true)).filter(x => x.stockId == this.placement.stock?.stockId ?? null);

            var placementInfo = new PlacementInfoBox(this.placement.data, true, null);
            this.header_container.appendChild(placementInfo.container);

            //get items
            var data = await SP.Data.StockingLot.getPlacementStockingLotInfos(placementId);
            for (let i = 0; i < data.length; i++) {
                let lot = data[i];
                let elm = this.items[lot.item.id];
                if (elm == null) elm = this.addItem(lot.item, false, 1);
                elm.addLot(lot);
            }
            this.updateChangeCount();
            this.content_container.style.display = "";
            this.placeholder_container.style.display = "none";
            this.button_add_item.classList.remove("disabled");
            this.button_reset.classList.remove("disabled");
            StopLoading();
        }

        addItem(item: SP.ItemInfo, new_item: boolean, qty: number) {
            let elm = this.items[item.id] = new AuditItem(item, new_item, qty);
            this.items_container.appendChild(elm.container);
            return elm;
        }

        changes = 0;
        updateChangeCount() {
            this.changes = 0;
            for (let id in this.items) {
                if (this.items[id].amt != this.items[id].max) this.changes++;
            }
            this.change_count_container.innerHTML = this.changes.toString();
        }

        async scanTote(scanId: string) {
            var ti = await SP.Data.Tote.getToteInfo(scanId, false);
            this.selectPlacementId(ti.totePlacementId);
        }

        scanTime: number;
        async scanPlacement(scanId: string) {
            let pId = parseInt(scanId);
            if (this.placement != null && this.placement.placement.id == pId) {
                var now = performance.now();
                if (now - this.scanTime < 700 || App_Settings.userSettings.auto_double_scan_stocking) {
                    this.button_submit.click();
                }
                this.scanTime = now;
                return;
            }

            this.selectPlacementId(pId);
        }

        async scanBarcode(barcode: string) {
            if (this.placement == null) {
                SP.Sounds.Error.play();
                return;
            }

            if (barcode != null) {
                barcode = barcode.trim().replace(/^0+/, '');
                for (let id in this.items) {
                    let elm = this.items[id];
                    for (var code in elm.item.allBarcodes) {
                        if (code.includes(barcode) || barcode.includes(code)) {
                            elm.focus();
                            var qty = elm.item.allBarcodes[code];
                            return elm.updateAmount(qty ? qty : 1, false);
                        }
                    }
                }
            }




            itemSearchAssistant.open(this.stockCustomers?.length == 1 ? this.stockCustomers[0].customerId : null, barcode ?? "", false, (info) => {
                let current = this.items[info.id];
                var qty = GetBarcodeQty(info.allBarcodes, barcode);

                if (current != null) current.updateAmount(qty ?? 1, false);
                else current = this.addItem(info, true, qty ?? 1);
                current.focus();
            });
        }

    }
    RegisterApp("app_audit_placement", App_audit_placement);
}